module.exports = __webpack_public_path__ + "static/media/sentinel_ecosystem.20ff2442.png";